import { useState, useEffect, useRef, useContext } from 'react';
import { Link, useNavigate } from "react-router-dom";
import { IconButton, Button } from '@mui/material';
import dayjs from 'dayjs';
import axios from "axios";
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import Tooltip from '@mui/material/Tooltip';
import { DataGrid, jaJP } from '@mui/x-data-grid';
import { API, MSG, PAGE_SIZE } from "./constantsFront";
import { MsgContext } from '../../App';

/**
 * お知らせ一覧
 * @returns 
 */
function G011NewsList() {
  var rows = [];
  const [newsList, setNews] = useState("");
  const [pageSize, setPageSize] = useState(PAGE_SIZE);
  const navigate = useNavigate();

  // エラーメッセージ
  const { msg, setMsg } = useContext(MsgContext);

  let body = { authKey: API.API_KEY };

  // useEffect初回読込フラグ
  const refIsFirst = useRef(true);

  // 更新履歴一覧取得
  useEffect(() => {
    // 初回読込チェック
    if (!refIsFirst.current) {
      return;
    }

    body.order = "DESC";
    const res = axios.post("/m_news/select/auth", body)
      .then(res => {
        setNews(res.data.newsList);
      });
    // const res = axios.post("/m_news/select/auth", body);
    // 認証エラー
    // if (res.status == 210) {
    //   setMsg(MSG.TIMEOUT_LOGIN);
    //   navigate("/G009AdminLogin");
    //   return;
    // }
    // setNews(res.data.newsList);

    // 初回読込フラグをfalseにセット
    refIsFirst.current = false;


  }, [])

  // ヘッダー
  const columns = [
    { field: 'publish_date', headerName: '公開日時', width: 150 },
    { field: 'title', headerName: 'タイトル', flex: 1 },
    // { field: 'content', headerName: '内容', width: 300 },
    {
      field: 'delete', headerName: '', sortable: false, disableClickEventBubbling: true, width: 50,
      renderCell: (params) => <Link to={"/G012NewsEdit"} state={{ ID: params.id }}><Tooltip title="編集" arrow><IconButton ><EditIcon /></IconButton></Tooltip></Link>
    },
    {
      field: 'edit', headerName: '', sortable: false, disableClickEventBubbling: true, width: 50,
      renderCell: (params) => <Tooltip title="削除" arrow><IconButton onClick={() => deleteNews(params.id)}><DeleteIcon /></IconButton></Tooltip>
    },
  ];

  // 表示データ
  for (var i in newsList) {
    var publish_date = dayjs(newsList[i].publish_date).format('YYYY-MM-DD HH:mm:ss');
    rows.push({ id: newsList[i].news_id, publish_date: publish_date, title: newsList[i].title, content: newsList[i].content });
  }

  // 削除ボタン処理
  async function deleteNews(select_id) {
    var csletr = [];
    var arrStr = [];

    if (window.confirm('削除してもよろしいですか？')) {
      console.log('削除処理開始');
      csletr.push(select_id);
      var arrStr = JSON.stringify(csletr);
      body.arrStr = arrStr;
      var res = await axios.post("/m_news/delete/auth", body);
      // 認証エラー
      if (res.status == 210) {
        setMsg(MSG.TIMEOUT_LOGIN);
        // navigate("/G009AdminLogin");
        return;
      }
      if (res.status === 200) {
        return window.location.reload();
      } else {
        return console.log("削除失敗");
      }
    } else {
      console.log('キャンセル');
    }
  }

  return (
    <>
      <div class="mainLinkMenu"></div>
      <div id="homeContents">
        <div class="homeContentsInner">
          <div class="mainCont">
            <div class="selectSearchArea">
              <Container maxWidth="lg">
                <Stack spacing={2}>

                  <h1>更新履歴一覧</h1>

                  <Button component={Link} to={"/G012NewsEdit"} state={{ ID: -1 }}
                    style={{ width: "200px", color: "white", textDecoration: "none" }}>
                    新規追加
                  </Button>

                  <div style={{ width: '100%' }}>
                    <DataGrid
                      className='DataGrid'
                      columns={columns}
                      rows={rows}
                      autoHeight
                      disableSelectionOnClick
                      pageSize={pageSize}
                      onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                      pagination
                      localeText={jaJP.components.MuiDataGrid.defaultProps.localeText}
                    />
                  </div>
                </Stack>
              </Container>
            </div>
          </div>
        </div>
      </div>
    </>

  );
}

export default G011NewsList;